import boris from "../media/speakers/Boris Kolev.png";
import hristob from "../media/speakers/Hristo Boyadzhiev.png";
import hristop from "../media/speakers/Hristo Popov.png";
import zarko from "../media/speakers/Svetozar Georgiev.png";

const panels = {
    panel1: [
        {
            speakerName: "Christo Popov",
            company: "Speech topic - The Importance of Execution: Three Main Reasons Why Startups Fail",
            businessSphere: "Blockchain, Crypto",
            theme: "Founder and CEO of Fast Track, Senior Rockefeller Coach",
            socialLink: "https://www.linkedin.com/in/chpopov/",
            img: hristop,
            bio: "Christo Popov holds an MBA from Cambridge. He is a seasoned CEO, entrepreneur, and investor with an extensive corporate background spanning three decades as a senior executive with multinational giants like McKinsey, Shell, Sab Miller, InBev, and Intersnack. Christo combined his corporate expertise with his entrepreneurial passion to become the founder and manager of more than 25 companies across 10 countries in Europe.",
        },
    ],
    panel2: [
        {
            speakerName: "Svetozar Georgiev",
            company: "Speech topic - Culture is Key for Success in a Startup",
            businessSphere: "Renewable Energy",
            theme: "Co-founder of Telerik, Telerik Academy, and Campus X",
            socialLink: "https://www.linkedin.com/in/svetozar-georgiev/",
            img: zarko,
            bio: "Svetozar holds a BA in Business Administration and a BA in Journalism and Mass Communications from AUBG When Progress Software acquired Telerik in 2014, Svetorar decided to dedicate much of his time to helping the next generation of Bulgarian entrepreneurs thrive. Svetozar is a mentor, advisor, and angel investor who works with numerous startups and community organizations. ",
            
        },
   
    ],
    panel3: [
        {
            speakerName: "Hristo Boyadzhiev",
            company: "Speech topic - Social Entrepreneurship in Bulgaria: 3 Lessons You Need to Learn",
            businessSphere: "Renewable Energy",
            theme: "Founder of Tuk-Tam and Parent Academy",
            socialLink: "https://www.linkedin.com/in/hboyadzhiev/",
            img: hristob,
            bio: "BA in Marketing and IT from the American University - Kogod School of Business in Washington. Tuk-Tam is dedicated to helping well-educated young professionals find their way back to or stay connected with their home country. It aims to provide up-to-date information about work, education, and community. The cause of Parent Academy is to provide all prospective and current parents with objective data and real knowledge about the health, education, and upbringing of children.",
        }
    ],
    panel4: [
        {
            speakerName: "Boris Kolev",
            company: "Speech topic - Innovate with Purpose: Overcoming Obstacles with a Cause in Mind",
            businessSphere: "Renewable Energy",
            theme: "Co-founder of nPloy, NutriGen, Airate, etc.",
            socialLink: "https://www.linkedin.com/in/boriskolev/",
            img: boris,
            bio: 'BA in Marketing and Management from the University of Portsmouth. Boris Kolev is social entrepreneur and investor who has founded numerous companies and non-profit projects in Europe and the USA. His main focus is sustainable development and innovation. In 2017, Boris was included in the European "FERD\'s List" which presents the 6 young entrepreneurs with the highest social impact in Europe. At the age of 18, he was positioned as the 2nd best young entrepreneur in Europe.',
        }
    ],
};

export default panels;
